<template>
  <div>
    <page-title>Shipping Application Report</page-title>
    <b-loading :is-full-page="true" :active.sync="$apollo.loading" :can-cancel="false"></b-loading>
    <div v-if="!$apollo.loading" class="columns is-multiline is-centered">
      <div class="column is-8">
        <bar-chart :chartdata="getChartData"></bar-chart>
      </div>
    </div>
  </div>
</template>

<script>
import GetShippingRequestReport from "@/modules/nimasaAgentModule/api/graphql/queries/GetShippingRequestReportsForNimasa.gql";
import * as moment from "moment";

import BarChart from "@/modules/nimasaAgentModule/components/BarChart.vue";

export default {
  name: "ShippingApplicationReport",
  components: { BarChart },

  apollo: {
    shippingRequestReport: {
      query: GetShippingRequestReport,
      variables() {
        return {
          start_date: moment("2019-01-01", "YYYY-MM-DD").format("YYYY-MM-DD"),
          end_date: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD")
        };
      },
      update: data => data.getShippingRequestsReportForNimasa
    }
  },

  data() {
    return {
      shippingRequestReport: {},
      chartData: null
    };
  },
  computed: {
    getChartData() {
      if (this.shippingRequestReport) {
        return this.fillData();
      }
    }
  },
  methods: {
    fillData() {
      return {
        labels: [
          "All Shipping Applications",
          "Approved Applications",
          "Pending Approval",
          "Pending Review",
          "Denied Applications",
          "Rejected Applications",
          "Completed Applications"
        ],
        datasets: [
          {
            label: "Shipping Applications Info",
            backgroundColor: [
              "rgba(54, 162, 255, 0.2)",
              "rgba(34, 255, 23, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 0, 0, 0.2)",
              "rgba(255, 0, 0, 0.2)",
              "rgba(255, 159, 64, 0.2)"
            ],
            data: [
              this.shippingRequestReport.all_shipping_requests,
              this.shippingRequestReport.approved_shipping_requests,
              this.shippingRequestReport.pending_approval_shipping_requests,
              this.shippingRequestReport.awaiting_processing_shipping_requests,
              this.shippingRequestReport.failed_processing_shipping_requests,
              this.shippingRequestReport.disapproved_shipping_requests,
              this.shippingRequestReport.completed_shipping_requests
            ],
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
<style scoped="">
</style>


